// axiosClient.js
import axios from 'axios';
import config from '../config';

const APPLICATION_ID = config.APPLICATION_ID || 'application-id';


const landingPageUrl =
  typeof window !== 'undefined' ? window.location.href : null;
const landingPageReferrer =
  typeof window !== 'undefined' ? document.referrer || '' : '';

let attributionHeadersSent = false;


const axiosClient = axios.create({
  withCredentials: true,
  headers: {
    'X-Application-Id': APPLICATION_ID,
  },
});

axiosClient.interceptors.request.use(
  (requestConfig) => {
    if (typeof window === 'undefined' || attributionHeadersSent) {
      delete requestConfig.attribution;
      return requestConfig;
    }

    //
    if (
      typeof window !== 'undefined' &&
      !attributionHeadersSent &&
      landingPageUrl
    ) {
      requestConfig.headers['X-Page-Url'] = landingPageUrl;
      requestConfig.headers['X-Page-Referrer'] = landingPageReferrer;

      const gaClientId =
        (typeof document !== 'undefined' &&
          document.cookie
            .split('; ')
            .find((row) => row.startsWith('_ga='))
            ?.split('=')[1]) ||
        null;
      
      if (gaClientId) {
        requestConfig.headers['X-GA-Client-Id'] = gaClientId;
      }
      attributionHeadersSent = true;
    }
    //
    return requestConfig;
  },
  (error) => Promise.reject(error),
);

export default axiosClient;
